import { useAction, useAtom } from "@reatom/npm-react";
import {
  init,
  initDataRaw,
  initDataStartParam,
  isTMA,
  miniApp,
  offBackButtonClick,
  onBackButtonClick,
  viewport,
} from "@telegram-apps/sdk-react";
import { useEffect } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router";
import {
  SafeAreaInsetTopAtom,
  SafeContentAreaInsetTopAtom,
} from "./core/reatom/state/SafeAreaInsetTop";
import { CheckoutPage } from "./pages/CheckoutPage/CheckoutPage";
import { CurrentServicePage } from "./pages/CurrentServicePage/CurrentServicePage";
import { FreelancerPage } from "./pages/FreelancerPage/FreelancerPage";
import { HomePage } from "./pages/HomePage/HomePage";
import { OnBoardingPage } from "./pages/OnBoardingPage/OnBoardingPage";
import { getToken } from "./core/api/requests/getToken";
import { userAtom } from "./core/reatom/state/user/user";
import { MessagesPage } from "./pages/MessagesPage/MessagesPage";
import { OrdersPage } from "./pages/OrdersPage/OrdersPage";
import { ProfilePage } from "./pages/ProfilePage/ProfilePage";
import { toggleModal } from "./core/reatom/state/modal/modal";

export const AppRoutes = () => {
  const navigate = useNavigate();
  const [_, setSafeAreaInsetTop] = useAtom(SafeAreaInsetTopAtom);
  const [safeContent, setSafeContentAreaInsetTop] = useAtom(
    SafeContentAreaInsetTopAtom
  );

  useEffect(() => {
    async function initTg() {
      if (await isTMA()) {
        init();

        if (viewport.mount.isAvailable()) {
          await viewport.mount();
        }

        if (viewport.bindCssVars.isAvailable()) {
          viewport.bindCssVars();
        }

        if (viewport.expand.isAvailable()) {
          viewport.expand();
        }

        if (viewport.requestFullscreen.isAvailable()) {
          await viewport.requestFullscreen();
          setSafeAreaInsetTop(viewport.safeAreaInsetTop());
          setSafeContentAreaInsetTop(viewport.contentSafeAreaInsetTop());
        }
      }
    }
    initTg();
  }, []);

  useEffect(() => {
    const listener = () => {
      if (window.history.state?.idx > 0) {
        navigate(-1);
      } else {
        miniApp.close();
      }
    };
    onBackButtonClick(listener);
    return () => {
      offBackButtonClick(listener);
    };
  }, [navigate]);

  const initData = initDataRaw();
  const [user, setUser] = useAtom(userAtom);
  const handleToggleModal = useAction(toggleModal);
  useEffect(() => {
    if (initData && user === null) {
      getToken(initData).then((access) => {
        setUser(access);
        const startParam = initDataStartParam();

        if (startParam) {
          const oid = startParam.split("-")[1];
          if (oid && !isNaN(+oid) && !isNaN(parseFloat(oid))) {
            navigate("checkout/" + oid);
          }

          if (oid === "callback") {
            handleToggleModal("auth-error");
          }
        }
      });
    }
  }, [initData, user]);

  return (
    <Routes>
      <Route index element={<HomePage />} />
      <Route path="service/:id" element={<CurrentServicePage />} />
      <Route path="profile" element={<ProfilePage />} />

      <Route path="orders" element={<OrdersPage />} />
      <Route path="checkout/:id" element={<CheckoutPage />} />
      <Route path="messages/:id" element={<MessagesPage />} />
      <Route path="onboarding" element={<OnBoardingPage />} />
      <Route path="freelancer/:id" element={<FreelancerPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
